





import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import homeModule from '@/store/home'
import userModule from '@/store/user'
import dealModule from '@/store/deal'
import DealDetail from '@/components/deal/DealDetail.vue'
import { Deal } from '@/types/Deal'

declare let google: any

@Component({
  name: 'FMap',
  components: {
    DealDetail
  }
})
class FMap extends Vue {
  @Prop() readonly locations!: any[]
  @Prop() readonly showPopups?: boolean
  @Prop({ required: false }) readonly deals?: Deal[]
  private map: any = null
  private allMarkers: any[] = []
  private googleAPI = (window as any).google.maps

  private get isCardView(): boolean {
    return this.$route.name === 'HomeDeals'
  }

  @Watch('locations')
  private async setMap(): Promise<void> {
    this.map = new this.googleAPI.Map(this.$el.children[0], {
      center: { lat: 50, lng: 7 },
      zoom: 8
    })

    if (this.locations.length === 0 && userModule.location) {
      this.map.setCenter(userModule.location)
      return
    }

    let maxLat = this.locations[0].location.coordinates[1]
    let minLat = this.locations[0].location.coordinates[1]
    let maxLng = this.locations[0].location.coordinates[0]
    let minLng = this.locations[0].location.coordinates[0]

    for (const location of this.locations) {
      if (this.locations.length > 1) {
        maxLat =
          location.location.coordinates[1] > maxLat
            ? location.location.coordinates[1]
            : maxLat
        minLat =
          location.location.coordinates[1] < minLat
            ? location.location.coordinates[1]
            : minLat
        maxLng =
          location.location.coordinates[0] > maxLng
            ? location.location.coordinates[0]
            : maxLng
        minLng =
          location.location.coordinates[0] < minLng
            ? location.location.coordinates[0]
            : minLng
      }
      const marker = new this.googleAPI.Marker({
        position: {
          lat: location.location.coordinates[1],
          lng: location.location.coordinates[0]
        },
        map: this.map,
        icon: {
          url: require('@/assets/icon/icons8-marker.svg'),
          size: new this.googleAPI.Size(36, 36),
          scaledSize: new this.googleAPI.Size(36, 36)
        }
      })

      if (this.showPopups) {
        marker.addListener('click', () => {
          this.setIcons(marker)
          const deal = this.deals
            ? this.deals.find(d => d._id === location.dealId)
            : this.findDealById(location.dealId)
          if (!deal) return
          const infowindow = new this.googleAPI.InfoWindow({
            content: `<div class="info-window">
                      <img src=${deal.image} />
                      <div class="info-caption ">
                        ${deal.name}
                      </div>
                    </div>`
          })
          infowindow.addListener('closeclick', () => {
            this.setIcons(marker, true)
          })
          infowindow.open(this.map, marker)
        })
      }

      this.allMarkers.push(marker)
    }

    if (this.locations.length == 1) {
      this.map.setCenter(
        new google.maps.LatLng(
          this.locations[0].location.coordinates[1],
          this.locations[0].location.coordinates[0]
        )
      )
    } else {
      await this.map.fitBounds({
        east: maxLng,
        north: maxLat,
        west: minLng,
        south: minLat
      })
    }
    if (this.locations.length <= 1) {
      this.map.setZoom(14)
    }
  }

  public panToVenue(locationIndex: number): void {
    this.map.panTo(
      new google.maps.LatLng(
        this.locations[locationIndex].location.coordinates[1],
        this.locations[locationIndex].location.coordinates[0]
      )
    )
  }

  private async mounted(): Promise<void> {
    if (this.isCardView) {
      await homeModule.setCardById(this.$route.params.cardId)
      await dealModule.setDeals(homeModule.card!.deals)
    } else {
      await dealModule.fetchAll()
    }
    this.setMap()
  }

  private setIcons(currentMarker: any, reset?: boolean): void {
    if (reset) {
      currentMarker.setIcon({
        url: require('@/assets/icon/icons8-marker.svg'),
        size: new this.googleAPI.Size(36, 36),
        scaledSize: new this.googleAPI.Size(36, 36)
      })
      return
    }
    for (const marker of this.allMarkers) {
      marker.setIcon({
        url: require('@/assets/icon/icons8-marker.svg'),
        size: new this.googleAPI.Size(36, 36),
        scaledSize: new this.googleAPI.Size(36, 36)
      })
    }
    currentMarker.setIcon({
      url: require('@/assets/icon/icons8-marker-active.svg'),
      size: new this.googleAPI.Size(36, 36),
      scaledSize: new this.googleAPI.Size(36, 36)
    })
  }

  private findDealById(id: string) {
    for (const deal of dealModule.deals) {
      if (deal._id === id) {
        return deal
      }
    }
  }
}

export default FMap
